export default __webpack_public_path__ + "static/media/kirsh.2e0916b9.png";